const breakpoints = {
    sm: '576px',
    md: '768px', 
    lg: '1140px',
}

export default breakpoints